// extracted by mini-css-extract-plugin
export default {"content":"content___DiNrm","contentIsLoading":"contentIsLoading___oFqKb content___DiNrm"};